import React from 'react'
import useBusinessTypes from '../hooks/api/useBusinessTypes'
import useCompanyConfig from '../hooks/api/useCompanyConfig'

import {
  Box,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
} from '@mui/material'
import SettingsFooter from './shared/SettingsFooter'
import useAlert from '../hooks/useAlert'

export const BusinessTypeForm = ({
  setCompanyConfig,
  companyConfig,
  businessTypes,
  isLoading,
}) => {
  if (isLoading) return <CircularProgress />

  return (
    <Box>
      <Typography>
        What type of business do you have? Business to Business (B2B), Business
        to Customer B2C, or Both B2B and B2C?
      </Typography>

      <FormControl>
        <RadioGroup
          value={companyConfig.businessTypeId || 1}
          name='radio-buttons-group'
          onChange={(e) => {
            setCompanyConfig({
              ...companyConfig,
              businessTypeId: Number(e.target.value),
            })
          }}
        >
          {businessTypes.map((bt) => {
            const label = bt.abbreviation
              ? `${bt.name} (${bt.abbreviation})`
              : bt.name

            return (
              <FormControlLabel
                key={bt.id}
                value={bt.id}
                control={<Radio />}
                label={label}
              />
            )
          })}
        </RadioGroup>
      </FormControl>
    </Box>
  )
}

const BusinessType = () => {
  const { businessTypes, ...bt } = useBusinessTypes()

  const { setCompanyConfig, updateCompanyConfig, companyConfig, ...cc } =
    useCompanyConfig()

  const { createAlert, createGenericErrorAlert } = useAlert()
  const onSuccess = () =>
    createAlert({
      severity: 'success',
      message: 'Successfully saved Business Type',
    })

  const onFailure = () => createGenericErrorAlert()

  const isLoading = bt.isLoading || cc.isLoading

  return (
    <>
      <BusinessTypeForm
        setCompanyConfig={setCompanyConfig}
        companyConfig={companyConfig}
        businessTypes={businessTypes}
        isLoading={isLoading}
      />

      <SettingsFooter
        saveButton={{
          onClick: () => updateCompanyConfig().then(onSuccess).catch(onFailure),
        }}
      ></SettingsFooter>
    </>
  )
}

export default BusinessType
